import hasClass from '../../../general/class/hasClass';
import hasAttr from '../../../general/attr/hasAttr';
import isObject from '../../../general/isObject';

import * as exRequest from '../../../utils/request';

import type { Context } from '../types';

// ----------------------------------------------------------------------------

function request(ctx: Context): any {
    ctx.shared.state.request = {};

    function init(): void {
        start();
    }

    // --------------------------------------------------------------------

    function start(): void {
        // Ensure ajax config exists
        if (!ctx.shared.config.ajax) {
            return;
        }

        // Get function done (before)
        const fnDoneBefore = ctx.shared.config.ajax.fnDone;

        // Function Done (after)
        const fnDoneAfter = function (this, data): any {
            //
            ctx.shared.state.request.isLoaded = true;

            // If using function done (before)
            if (typeof fnDoneBefore === 'function') {
                data = fnDoneBefore.call(this, data);
            }

            //
            let config: Record<string, any> = {};

            // If data is object
            if (isObject(data)) {
                config = data;
            }
            // Is default
            else {
                config.data = data;
            }

            //
            ctx.helpers.addOptions(config);

            //
            ctx.progress.stop();
        };
        ctx.shared.config.ajax.fnDone = fnDoneAfter;

        // ----------------------------------------------------------------

        // Get function fail (before)
        const fnFailBefore = ctx.shared.config.ajax.fnFail;

        // Function Fail (after)
        const fnFailAfter = function (this, data): any {
            // If using function fail (before)
            if (typeof fnFailBefore === 'function') {
                fnFailBefore.call(this, data);
            }

            //
            ctx.progress.stop();
        };
        ctx.shared.config.ajax.fnFail = fnFailAfter;

        // ----------------------------------------------------------------

        // Create event (mousedown)
        ctx.shared.elements.element.addEventListener('mousedown', function (): any {
            // If you clicked this element (select text)
            if (
                hasClass(ctx.shared.elements.text.element, 'show') ||
                hasAttr(ctx.shared.elements.text.input, 'disabled')
            ) {
                return;
            }

            //
            if (ctx.shared.config.isResetRequest === true) {
                ctx.shared.state.request.isLoaded = false;
            }

            //
            if (ctx.shared.state.request.isLoaded === true) {
                return;
            }

            //
            send();
        });
    }

    function send(): void {
        //
        ctx.progress.start();

        // Request Ajax
        exRequest.ajax({
            merge: ctx.shared.config.ajax,
        });
    }

    // --------------------------------------------------------------------

    function reload(): void {
        ctx.helpers.clear();
        send();
    }

    function clear(): void {
        ctx.shared.state.request.isLoaded = false;
    }

    // --------------------------------------------------------------------

    return {
        init,
        reload,
        clear,
    };
}

// ----------------------------------------------------------------------------

export default request;
